module.exports = __webpack_public_path__ + "img/Slovakia_GP2 - Aj ty v IT.62bed596.png";